import { render, staticRenderFns } from "./DocumentFilingDetails.vue?vue&type=template&id=24b2ac93"
import script from "./DocumentFilingDetails.vue?vue&type=script&lang=js"
export * from "./DocumentFilingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports